import { render, staticRenderFns } from "./ChatCorrespondence.vue?vue&type=template&id=0a37b1e8&scoped=true&"
import script from "./ChatCorrespondence.vue?vue&type=script&lang=js&"
export * from "./ChatCorrespondence.vue?vue&type=script&lang=js&"
import style0 from "./ChatCorrespondence.vue?vue&type=style&index=0&id=0a37b1e8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a37b1e8",
  null
  
)

export default component.exports